module.exports = __webpack_public_path__ + "static/media/Carvanha_gaussian2.b554298d.png";